<template>
  <div class="record_item">
    <div class="bulu" v-if="info.recordStatus == '2'">
      <span>补录</span>
    </div>
    
    <div class="record_top">
      <div class="record_top-left">
        <img src="../assets/images/icon-clock.png"/>
        <p class="record_top_time">{{info.recordStatus == '2' ? info.updateTime : info.createTime}}</p>
      </div>
      <!-- <span class="temp" :class="{'no_f': info.temperatureStatus == '0'}">
        {{info.temperatureStatus == '0' ? '' : info.temperature + '℃'}}
      </span> -->
    </div>
    <p v-if="info.temperatureStatus">温度是否高于37.3℃：
      <span class="temp" :class="{'no_f': info.temperatureStatus == '0'}">
        {{info.temperatureStatus == '0' ? '否' : '是'}} {{info.temperatureStatus == '0' ? '' : info.temperature + '℃'}}
      </span>
    </p>
    <p v-if="info.symptomStatus">是否有咳嗽、腹泻等症状：<span :class="{'red': info.symptomStatus == '1'}">{{info.symptomStatus == '0' ? '否' : '是'}}</span></p>
    <p v-if="info.city">今日所在城市：{{info.city}}{{info.address}}</p>
    <p v-if="info.communityStatus">小区是否封闭：{{info.communityStatus == '0' ? '可外出' : '封闭'}}</p>
    <p v-if="info.diagnosisStatus">是否有疑似或确诊：<span :class="{'red': info.diagnosisStatus == '1'}">{{info.diagnosisStatus == '0' ? '否' : '是'}}</span></p>
    <p v-if="info.acidStatus">是否核酸：{{info.acidStatus == '0' ? '否' : '是'}}</p>
    <p v-if="info.acid">核酸结果：<span :class="{'red': info.acid == '2'}">{{info.acid == '1' ? '阴性' : info.acid == '2' ? '阳性' : '未出结果'}}</span></p>
    <p v-if="info.outStatus">今日是否外出：{{info.outStatus == '0' ? '否' : '是'}}</p>
    <p v-if="info.outPoints">具体外出地点：{{info.outPoints}}</p>
    <p v-if="info.leaveStatus">
      {{orgid == 233 ? '最近5天是否外出过市中区：' : '7日内出过本市：'}}
      <span :class="{'red': info.leaveStatus == '1'}">{{info.leaveStatus == '0' ? '否' : '是'}}</span>
    </p>
    <p v-if="info.leavePoints">具体去过的城市：{{info.leavePoints}}</p>
    <p v-if="info.dangerStatus">
      {{orgid == 233 ? '是否去过滕州、山亭、峄城等高风险地区：' : '高风险地区居旅史：'}}
      <span :class="{'red': info.dangerStatus == '1'}">{{info.dangerStatus == '0' ? '否' : '是'}}</span>
    </p>
    <p v-if="info.dangerPoints">去过的高风险地区：{{info.dangerPoints}}</p>
    <p v-if="info.contactStatus">高风险区人员接触：<span :class="{'red': info.contactStatus == '1'}">{{info.contactStatus == '0' ? '否' : '是'}}</span></p>
    <p v-if="info.abordStatus">是否境外来本市：<span :class="{'red': info.abordStatus == '1'}">{{info.abordStatus == '0' ? '否' : '是'}}</span></p>
    <p v-if="info.abordCity">从哪里来：{{info.abordCity}}</p>
    <p v-if="info.others" class="other_info">有无其他症状及处理情况：{{info.others}}</p>
    <p v-if="info.todayTemp">今日体温：<span>{{info.todayTemp}}℃</span></p>
    <p v-if="info.todayAcid">今日是否核酸：{{info.todayAcid == '0' ? '否' : '是'}}</p>
    <p v-if="info.yesterdayAcid">昨日是否核酸：{{info.yesterdayAcid == '0' ? '否' : '是'}}</p>
    <p v-if="info.checkStatus">是否为应检尽检人员：{{info.checkStatus == '0' ? '否' : '是'}}</p>
    <p v-if="info.healthImg">健康码：<span class="click_look" @click="handleShowImage({image: info.healthImg})">点击查看</span></p>
    <p v-if="info.travelImg">行程码：<span class="click_look" @click="handleShowImage({image: info.travelImg})">点击查看</span></p>
    <p v-if="info.acidImg">核酸检测报告：<span class="click_look" @click="handleShowImage({image: info.acidImg})">点击查看</span></p>
    <p v-if="info.commonImg">
      {{orgid == 211 ? '共同居住人行程吗及核酸检测报告：' : '共同居住人核酸检测报告：'}}
      <span class="click_look" @click="handleShowImage({images: info.commonImg})">点击查看</span>
    </p>
  </div>
</template>

<script>
import { WebBridgeApi } from 'ijsbridge'
import { getUrlParam } from '../commen/util';
export default {
  props: {
    info: Object
  },
  data() {
    return {
      orgid: getUrlParam('_orgid_'),
    }
  },
  methods: {
    handleShowImage({ image, images }) {
      if(image) {
        WebBridgeApi.showImageViewer({
          images: [{image: image }],
          index:0
        })
      }
      if(images) {
        const list = JSON.parse(images)
        const preList = []
        list.map(item => {
          preList.push({
            image: item
          })
        })
        WebBridgeApi.showImageViewer({
          images: preList,
          index:0
        })
      }
    }
  }
}
</script>

<style scoped>
.record_item {
  position: relative;
  box-sizing: border-box;
  padding: .44rem .3rem;
  margin-bottom: .3rem;
  width: 100%;
  min-height: 3.1rem;
  background-color: #F9FAFE;
}
.record_top {
  display: flex;
  align-items: center;
  margin-bottom: .45rem;
  padding-bottom: .3rem;
  border-bottom: 1px solid #EAEAEA;
}
.record_top-left {
  display: flex;
  align-items: center;
  flex: 1;
}
.record_top-left > img {
  width: .36rem;
  height: .36rem;
  margin-right: .15rem;
}
.record_top > p {
  font-size: .32rem;
  color: #333;
}
.record_top .temp {
  color: #FF4040;
}
.record_top .no_f {
  color: #0baa3f;
}
.record_top > span {
  font-size: .32rem;
}
.record_top-left .record_top_time {
  font-size: .34rem;
  color: #333;
}
.record_item p {
  line-height: .48rem;
  font-size: .30rem;
  color: #999;
}
.click_look {
  color: #00aad5;
}
.other_info {
  white-space: normal;
  word-break: break-all;
}
.record_item p > .temp {
  color: #FF4040;
}
.record_item > p > .no_f {
  color: #0baa3f;
}
.red {
  color: #FF4040;
}
.bulu {
  position: absolute;
  top: .1rem;
  right: .2rem;
  padding: 0 .1rem;
  height: .32rem;
  border-radius: .16rem;
  background-color: #FF4040;
}
.bulu span {
  font-size: .28rem;
  line-height: .32rem;
  color: #fff;
}
</style>